import { FrontUrls } from 'Constants/FrontUrls'
import React, { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

const PartnerLazy = lazy(() => import('Pages/partner/partners/components/Main'))

export const PartnerRoutes = () => {
	return (
		<Switch>
			<Route path={FrontUrls.pp.partner} key={FrontUrls.pp.partner} component={PartnerLazy} />
		</Switch>
	)
}
